import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import PropertyType_v1 from './PropertyType_v1';
import type { Section } from '../../../models/index';
import { PROPERTY_TYPE } from '../../../constants/index';
import YesAndNo from '../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  setSection: (section: Section) => void;
};

function PropertyType_v6({ section, setSectionValues, setSection }: Props): JSX.Element {
  function onNoThreeUnitsOrMore(): void {
    setSectionValues({
      [PROPERTY_TYPE.FIELD_NAME.THREE_UNITS_OR_MORE]: false,
    });
  }

  function onYesThreeUnitsOrMore(): void {
    setSectionValues({
      [PROPERTY_TYPE.FIELD_NAME.THREE_UNITS_OR_MORE]: true,
    });
  }

  const isMultiFamily = section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY);

  return (
    <PropertyType_v1 {...{ section, setSectionValues, setSection }}>
      {isMultiFamily && (
        <>
          <FormField
            label={<Label>Does the property have 3 or more rental units?</Label>}
            control={
              <YesAndNo
                yesActive={section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.THREE_UNITS_OR_MORE)}
                yesHandler={onYesThreeUnitsOrMore}
                noHandler={onNoThreeUnitsOrMore}
              />
            }
          />
        </>
      )}
    </PropertyType_v1>
  );
}

export default PropertyType_v6;

PropertyType_v6.description = 'Asks if the MF is more than 3 rental units.';
